import React from 'react';
import { useMutation, useQuery, useReactiveVar } from '@apollo/client';
import BILLING_MUTATION from 'app/graphql/network/billing';

import { isSubscription, SUBSCRIPTION_TYPES } from 'app/const/subscription';
import { subscriptionTypeVar, paymentMethodVar, selectedPeriodVar } from 'app/apollo/reaction';
import { analyticService, errorService } from 'global/services';
import { GET_SUBSCRIPTION_TYPE } from 'app/graphql/client/subscription';

export const useToggleSubscription = () => {
    const paymentMethod = useReactiveVar(paymentMethodVar);
    const [mutateBilling] = useMutation(BILLING_MUTATION);
    const { data: { subscriptionType } } = useQuery(GET_SUBSCRIPTION_TYPE);

    const nextType = isSubscription(subscriptionType)
        ? SUBSCRIPTION_TYPES.singlePay
        : SUBSCRIPTION_TYPES.subscription;

    const toggleSubscriptionHandler = async () => {
        subscriptionTypeVar(nextType);
        analyticService
            .push({
                eventName: 'Check_Subscription_Toggle',
                eventValue: isSubscription(subscriptionType)
                    ? 'Check_Unselect_Subscription'
                    : 'Check_Select_Subscription',
            });
        try {
            mutateBilling({
                variables: {
                    period: selectedPeriodVar(),
                    payment_method: isSubscription(nextType)
                        ? 'recurrent'
                        : paymentMethod,
                },
            });
        } catch (e) {
            errorService.log({
                text: e?.text || 'Ошибка',
                source: 'server',
            });
        }
    };

    return [toggleSubscriptionHandler];
};
